export default __webpack_public_path__ + "static/media/nvidia.10f5c5b8.svg";